import { useState } from "react";

function CarBox({ data, carID, selectVehicle }) {
  const [carLoad, setCarLoad] = useState(true);
  const car = data[carID];
  return (
    <>
        <div key={carID} className="box-cars">
          {/* car */}
          <div className="pick-car">
            {carLoad && <span className="loader"></span>}
            <img
              style={{ display: carLoad ? "none" : "block" }}
              src={car.img}
              alt="car_img"
              onLoad={() => setCarLoad(false)}
            />
          </div>
          {/* description */}
          <div className="pick-description">
            <div className="pick-description__price">
             <span>{car.name}</span>
              {/* <span>₱{car.price}</span>/ rent per day */}
              {/* <span class="models-div__box__descr__name-price__btn" onClick={showRates}>Pricing</span> */}
            </div>

            <div className="pick-description__table">
              <div className="pick-description__table__col">
                <span>Model</span>
                <span>{car.model}</span>
              </div>

              <div className="pick-description__table__col">
                <span>Year</span>
                <span>{car.year}</span>
              </div>

              <div className="pick-description__table__col">
                <span>Seats</span>
                <span>{car.mark}</span>
              </div>

              <div className="pick-description__table__col">
                <span>Doors</span>
                <span>{car.doors}</span>
              </div>

              <div className="pick-description__table__col">
                <span>AC</span>
                <span>{car.air}</span>
              </div>

              <div className="pick-description__table__col">
                <span>Transmission</span>
                <span>{car.transmission}</span>
              </div>

              <div className="pick-description__table__col">
                <span>Fuel</span>
                <span>{car.fuel}</span>
              </div>
            </div>
            {/* btn cta */}

            <button className="cta-btn" onClick={()=>{selectVehicle();}}> 
            {/* <span className="cta-btn"> */}
              Reserve Now
            {/* </span> */}
            </button>
          </div>
        </div>
    </>
  );
}

export default CarBox;
